const approval = ({ history }) => {
  return <h2>approval</h2>;
};

export default approval;
